// Shared primitive UI building blocks for the Personal Financial Statement page
// and its companion dialogs. Pure presentational — no API calls, no state.

export const fmtUSD = (n) =>
  "$" + (Number(n) || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });

export const num = (v) =>
  v === "" || v === null || v === undefined ? 0 : Number(v) || 0;

export function MoneyInput({ value, onChange, testid }) {
  return (
    <div className="flex items-center gap-1">
      <span className="text-slate-400 text-sm">$</span>
      <input
        type="number"
        step="any"
        className="input-clean w-full text-right tabular-nums"
        value={value === 0 ? "" : (value ?? "")}
        onChange={(e) => onChange(e.target.value)}
        placeholder="0"
        data-testid={testid}
      />
    </div>
  );
}

export function KPI({ label, value, tone, testid, bgClass = "bg-white border-slate-200" }) {
  const toneClass =
    tone === "emerald"
      ? "text-emerald-700"
      : tone === "rose"
      ? "text-rose-700"
      : "text-slate-900";
  return (
    <div className={`${bgClass} border rounded-sm p-4`} data-testid={testid}>
      <div className="overline text-slate-500">{label}</div>
      <div className={`text-3xl font-bold font-mono tabular-nums tracking-tight ${toneClass}`}>
        {fmtUSD(value)}
      </div>
    </div>
  );
}

export function Card({ title, total, totalTestId, right, children, bgClass = "bg-white border-slate-200" }) {
  return (
    <div className={`${bgClass} border rounded-sm p-4`}>
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <div className="overline text-slate-700">{title}</div>
        {right
          ? right
          : total !== undefined && (
              <div
                className="flex items-baseline gap-2 text-sm text-slate-700"
                data-testid={totalTestId}
              >
                <span className="overline text-slate-500">Subtotal</span>
                <span className="font-mono tabular-nums font-bold min-w-[170px] text-right">
                  {fmtUSD(total)}
                </span>
              </div>
            )}
      </div>
      {children}
    </div>
  );
}

export function Row({ label, muted, children }) {
  return (
    <div className="grid grid-cols-[1fr_180px] items-center gap-2">
      <div className={`text-sm ${muted ? "text-slate-500 italic" : "text-slate-700"}`}>
        {label}
      </div>
      <div>{children}</div>
    </div>
  );
}

export function Field({ label, value, onChange, testid }) {
  return (
    <label className="block">
      <div className="overline text-slate-500 mb-1">{label}</div>
      <input
        type="text"
        className="input-clean w-full"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
      />
    </label>
  );
}
